import { render, staticRenderFns } from "./NoRmasFound.vue?vue&type=template&id=a5b7f5d0&"
import script from "./NoRmasFound.vue?vue&type=script&lang=js&"
export * from "./NoRmasFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports